import React from "react";
import Auxiliary from "../HOC/Auxiliary";
import "./Footer.css";

const Footer = (props)=>{
    return(
        <Auxiliary>
            <footer id="footer" className="main_footer_container flex-column">
                <div className="footer_upper flex-row">
                    <ul>
                        <li>Egypt</li>
                    </ul>
                    <div className="copyright flex-column">
                       <span>This site is for personal use</span>
                        <span>&copy; 2020 Google clone made by Mahmoud Farargy</span> 
                    </div>
                    
                    
                </div>
                <div className="footer_bottom flex-row">
                    <ul className="footer_bottom_left_ul flex-row desktop-only">
                        <li>advertising</li>
                        <li>business</li>
                        <li>about</li>
                    </ul>
                    <ul className="footer_bottom_right_ul flex-row">
                        <li>privacy</li>
                        <li>terms</li>
                        <li>settings</li>
                    </ul>
                </div>
            </footer>
        </Auxiliary>
    )
}
export default Footer;